<div class="row">
  <div class="col-12 col-md-4">
    <sb-card [loading]="loading">
      <div card-body>
        <form [formGroup]="form">
          <div class="form-group">
            <label class="form-label" for="groupname">{{ 'lang.globals.roleName' | translate }}</label>
            <input (ngModelChange)="setRoleInfo('name', $event)" [ngModel]="role?.name" class="form-control"
                   formControlName="Title" id="groupname"
                   name="groupname" type="text">
            <div *ngIf="Title.dirty && Title.errors?.required"
                 class="alert alert-danger">{{ 'lang.globals.roleNameWarning' | translate }}
            </div>
          </div>
        </form>
      </div>
    </sb-card>
  </div>
  <div class="col-12 col-md-4">
    <sb-card [loading]="loading || rolesLoading">
      <div card-header>
        <sb-search-bar
          (searchAction)="roleSearchChanged($event)"
          [searchStr]="roleSearch"
          headline="{{ 'lang.headlines.roles' | translate }}"
          placeholder="{{ 'lang.globals.searchPlaceholder' | translate }}"
          searchTooltip="{{ 'lang.globals.searchPlaceholder' | translate }}"
          stopSearchTooltip="{{ 'lang.globals.stopSearchPlaceholder' | translate }}"></sb-search-bar>
      </div>
      <div card-body>
        <ng-container *ngIf="!loading">
          <ng-scrollbar style="height: 445px;">
            <ng-container *ngFor="let r of roles">
              <div class="form-check form-switch ml-2">
                <input (ngModelChange)="updateRoleInheritance(r)" [id]="r.id"
                       [ngModel]="checkIfSelected(r)" [disabled]="!isCustomRole"
                       role="switch" class="form-check-input"
                       type="checkbox" aria-checked="mixed">
                <label [for]="r.id" class="form-check-label">{{ r.name | sbDefaultRoleTranslate }}</label>
              </div>
            </ng-container>
          </ng-scrollbar>
        </ng-container>
      </div>
    </sb-card>
  </div>
  <div *ngIf="role" class="col-12 col-md-4">
    <sb-card [loading]="loading">
      <div card-header>
        <sb-search-bar (searchAction)="onPermissionSearch($event)"
                       [searchStr]="permissionSearch"
                       headline="{{ 'lang.globals.directPermissions' | translate }}"></sb-search-bar>
      </div>
      <div card-body>
        <div class="row" *ngIf="isCustomRole">
          <div class="col-6">
            <a (click)="selectAllPermissions()" class="w-100 btn btn-success">
              {{ 'lang.globals.selectAll' | translate }}
            </a>
          </div>
          <div class="col-6">
            <a (click)="selectNoPermissions()" class="w-100 btn btn-danger">
              {{ 'lang.globals.deselectAll' | translate }}
            </a>
          </div>
        </div>
        <form [formGroup]="formPermissions" class="mt-2">
          @if (!loading) {
            <ng-scrollbar style="height: 400px;">
              @for (c of displayedPermissions?.sort(); track c) {

                <div class="form-check form-switch ml-2">
                  <input (ngModelChange)="updateRolePermissions(c, $event)" [formControlName]=c [id]=c
                         role="switch" class="form-check-input" [checked]="role.explicitPermissions.includes(c)"
                         type="checkbox" aria-checked="mixed">
                  <label [for]=c class="form-check-label">
                      <span [ngClass]="hasEffectivePermission(c)? 'green font-weight-bold' : ''">
                        {{ c | sbPermissionTranslate }}
                      </span>
                  </label>
                </div>
              }
            </ng-scrollbar>
          }
        </form>
      </div>
    </sb-card>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-default" (click)="close(false)">{{ 'lang.globals.cancel' | translate }}</button>
  <button type="button" class="btn btn-primary" (click)="updateRole()"
          [disabled]="rolesLoading || loading || !form.valid">{{ (roleId ? 'lang.globals.save' : 'lang.globals.create')  | translate }}
  </button>
</div>
